import Head from '@/components/Head/Head';
import Page from '@/components/Page/Page';
import extractPageMetaFromRouteData from '@/helpers/extractPageMetaFromRouteData';
import { useInitialPageDataLayer } from '@/hooks/useInitialPageDataLayer/useInitialPageDataLayer';
import { PageModel } from '@/models/page';
import FiberOpticMap from '@uikit/components/FiberOpticMap/FiberOpticMap';
import { GlassFiberOpticMapPageProps } from './interfaces';

const GlassFiberOpticMapPage = (
  pageData: PageModel<GlassFiberOpticMapPageProps>
): JSX.Element => {
  const meta = extractPageMetaFromRouteData(pageData);
  const {
    props: { opticFiberMapData },
  } = pageData;

  useInitialPageDataLayer();

  return (
    <Page meta={meta}>
      <Head>
        <meta httpEquiv="X-Frame-Options" content="" />
      </Head>
      <FiberOpticMap opticFiberMapData={opticFiberMapData} fullScreen />
    </Page>
  );
};
export default GlassFiberOpticMapPage;
